import DefaultValidation from "@/services/validations/DefaultValidation";

export default class PrazoPagamentoValidation extends DefaultValidation{

  validate(model, refs) {
    let validated = true;

    Object.entries(model).forEach(([key, value]) => {
      if(value!=null && typeof value == "string") model[key] = value.trim();
    });

    if (model.descricao==null||model.descricao=='') {
      refs.nomeInput.focusedOut = true;
      validated = false;
    }

    if (model.idprazopagtoerp==null||model.idprazopagtoerp=='') {
        refs.idErpInput.focusedOut = true;
        validated = false;
      }

    return validated;
  }
}